export default function GET_CATEGORIES(area='',option={}) {
  const $containers = $('[data-plugin="getCategory"][data-content][data-module]',area)
  if( $containers.length == 0 ) return false
  const defarr = [] // containerごとのpromise格納
  $containers.each( (i,container) => {
    const opt = $.extend(true,{
      addAll: false,
      itemClass: '',
      allText: 'ALL',
      currentClass: 'current'
    },option,container.dataset)
    const d = new $.Deferred()
    defarr.push(d.promise())
    $.getCategory(container.dataset).done(list => {
      container.innerHTML = ''
      const $allLink = $(`<a href="/${container.dataset.content}/" class="${opt.itemClass}">${opt.allText}</a>`)
      if(opt.addAll) container.appendChild( $allLink[0] )
      $.each(list,(i,cat) => {
        if(cat.name == '') return false
        const item = $(`<a href="/${container.dataset.content}/?mode=list&cat=${cat.id}" class="${opt.itemClass}">${cat.name}</a>`)
        container.appendChild( item[0] )
      })
      $(container).currentMenu()
      d.resolve(list)
    })
  })
  return $.when.apply($,defarr)
}